<template>
    <div class="driverDetail">
      <div class="baseinfo">
        <div class="info-header">
          <div class="avatar">
            <el-image style="width: 50px; height: 50px;" :src="mixinQiniuImg(driverInfo.headPortrait)" @click="editInfo('avatar')" alt="司机头像" />
          </div>
          <div class="basic-info">
            <div class="info-column-item">
              <div class="name">{{ driverInfo.name }}</div>
              <el-tag :type="driverInfo.isEnable === 1 ? 'success' : 'danger'" style="margin-left: 10px;" size="mini">{{
                driverInfo.isEnable === 1 ? '账号正常' : '账号封禁' }}</el-tag>
              <el-tag style="margin-left: 10px;" type="danger"
                v-if="$utils.checkValidity(driverInfo.idCardValid) < 0">身份证已过期</el-tag>
              <el-tag style="margin-left: 10px;" type="warning"
                v-else-if="$utils.checkValidity(driverInfo.idCardValid) < 30">身份证即将过期</el-tag>
              <el-tag style="margin-left: 10px;" type="danger"
                v-if="$utils.checkValidity(driverInfo.driverLicenceValid) < 0">驾驶证已过期</el-tag>
              <el-tag style="margin-left: 10px;" type="warning"
                v-else-if="$utils.checkValidity(driverInfo.driverLicenceValid) < 30">驾驶证即将过期</el-tag>
            </div>
            <div class="info-column-item">
              <span class="label">
                <span>手机：</span><span style="color: #101626;">{{ driverInfo.phone }}</span>
                <el-button type="text" size="medium" @click="editInfo('phone')">
                  <i class="el-icon-edit"></i>
                </el-button>
                <span>机构：</span><span style="color: #101626;">{{ driverInfo.organizationName }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
  
      <el-tabs v-model="activeName">
        <el-tab-pane label="司机信息" name="info">
          <documnetInfo v-if="activeName === 'info'" :info="driverInfo" @refresh="getDriverInfo" />
        </el-tab-pane>
        <el-tab-pane label="车辆号牌" name="vehicle">
          <vehiclePage v-if="activeName === 'vehicle'" :info="driverInfo" />
        </el-tab-pane>
        <el-tab-pane label="钱包账户" name="account">
          <driverAccountPage v-if="activeName === 'account'" :info="driverInfo" @refresh="getDriverInfo" />
        </el-tab-pane>
        <el-tab-pane label="背景审核" name="background">
          <driverBackgroundPage v-if="activeName === 'background'" :driverInfo="driverBackgroundInfo" :adverseRecord="adverseRecord" @submitSuccess="getAdverseRecord" />
        </el-tab-pane>
  
        <el-tab-pane label="监管数据" name="data" v-if="btnPreFn('travel_survey_driver', false)">
          <dataPage v-if="activeName === 'data'" :info="driverInfo" />
        </el-tab-pane>
        <el-tab-pane label="客运监管" name="supervise" v-if="btnPreFn('survey_driver', false)">
          <supervisePage v-if="activeName === 'supervise'" :info="driverInfo" />
        </el-tab-pane>
        <el-tab-pane label="订单记录" name="orders">
          <driverOrdersPage v-if="activeName === 'orders'" :info="driverInfo" />
        </el-tab-pane>
        <el-tab-pane label="收入统计" name="income">
          <driverIncomePage v-if="activeName === 'income'" :info="driverInfo" />
        </el-tab-pane>
      </el-tabs>
      <driverInfoDialog :visible.sync="driverInfoDialogVisible" :editType="editType" :driverInfo="driverInfo" :loading="loading"
        @submit="handleDriverInfoSubmit" />
    </div>
  </template>
  
  <script>
  import driverInfoDialog from "../components/detail/driverInfoDialog.vue";
  import documnetInfo from "../components/detail/information/informationPage.vue";
  import driverAccountPage from "../components/detail/driverAccount/driverAccountPage.vue";
  import dataPage from "../components/detail/data/dataPage.vue";
  import supervisePage from "../components/detail/supervise/supervisePage.vue";
  import vehiclePage from "../components/detail/vehicle/vehiclePage.vue";
  import driverBackgroundPage from "../components/detail/driverBackgroundPage/index.vue";
  import driverOrdersPage from "../components/detail/driverOrders/driverOrdersPage.vue";
  import driverIncomePage from "../components/detail/driverIncome/driverIncomePage.vue";
  export default {
    name: "driverDetail",
    components: {
      documnetInfo,
      driverInfoDialog,
      driverAccountPage,
      dataPage,
      supervisePage,
      vehiclePage,
      driverBackgroundPage,
      driverOrdersPage,
      driverIncomePage
    },
    data() {
      return {
        id: this.$route.query.id,
        activeName: 'info',
        driverInfo: {},
        driverBackgroundInfo: {},
        driverInfoDialogVisible: false,
        loading: false,
        showFullPhone: false,
        showFullIdCard: false,
        editType: 'phone',
        adverseRecord: {}
      };
    },
    computed: {
      maskIdCard() {
        return this.$utils.maskIdCard(this.driverInfo.idCard)
      },
      maskPhone() {
        return this.$utils.maskPhone(this.driverInfo.phone)
      }
    },
  
    watch: {
      activeName: {
        handler() {
          if (this.activeName === 'background') {
            this.getAdverseRecord()
          }
        },
      }
    },
    created() {
      this.getDriverInfo();
    },
    
    methods: {
      async getAdverseRecord() {
        let url = "/api/v1/manage/driver/adverse/record";
        const { code, data } = await this.$axios.get(url, {
          driverId: this.id,
        });
        if (code === 1) {
          this.adverseRecord = data;
        }
      },
      editInfo(type) {
        this.editType = type
        this.driverInfoDialogVisible = true
      },
      async handleDriverInfoSubmit(formData) {
        this.loading = true
        let url = "/api/v1/manage/driver";
        let params = {
          id: this.id,
          ...formData
        }
        let data = await this.$axios.put(url, params);
        if (data && data.code === 1) {
          this.$message.success("保存成功！");
          this.driverInfoDialogVisible = false
          this.getDriverInfo()
        }
        this.loading = false
      },
      // 获取司机详情
      async getDriverInfo() {
        if (!this.id) {
          return false;
        } else {
          this.flag = false;
        }
  
        let url = "/api/v1/manage/driver/" + this.id;
        let { code, data } = await this.$axios.get(url);
        if (code === 1) {
          this.driverBackgroundInfo = {
            id: data.id,
            name: data.name,
            idCard: data.idCard,
            phone: data.phone,
          }
          this.driverInfo = {
            ...data,
            // idCardValid: data.idCardValid ? this.$utils.timeFn(data.idCardValid * 1000, "YYYY-MM-DD") : "",
            idCardValidInput: data.idCardValid == 4102329600 ? "" :
              data.idCardValid ? this.$utils.timeFn(data.idCardValid * 1000, "YYYY-MM-DD") : "",
            driverLicenceValidInput: data.driverLicenceValid == 4102329600 ? "" :
              data.driverLicenceValid ? this.$utils.timeFn(data.driverLicenceValid * 1000, "YYYY-MM-DD") : "",
            qualificationsValidInput: data.qualificationsValid == 4102329600 ? "" :
              data.qualificationsValid ? this.$utils.timeFn(data.qualificationsValid * 1000, "YYYY-MM-DD") : "",
            firstIssueDate: data.firstIssueDate
              ? this.$utils.timeFn(data.firstIssueDate * 1000, "YYYY-MM-DD")
              : "",
          };
        }
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .driverDetail {
    padding-top: 100px;
  
    .baseinfo {
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      position: absolute;
      left: 0;
      top: 0;
      border-bottom: 16px solid #f5f5f5;
  
      .info-header {
        display: flex;
        align-items: center;
        height: 50px;
        box-sizing: border-box;
        // padding: 20px;
  
        /deep/ .el-button--medium {
          padding: 0 20px;
        }
  
        .avatar {
          width: 50px;
          height: 50px;
          flex-shrink: 0;
          text-align: center;
          line-height: 50px;
          border-radius: 50%;
          overflow: hidden;
        }
  
        .basic-info {
          height: 100%;
          margin-left: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
  
          .info-column-item {
            display: flex;
            align-items: center;
            font-family: SourceHanSansSC, SourceHanSansSC;
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            white-space: nowrap;
  
            .name {
              font-weight: 500;
              font-size: 18px;
              color: #333333;
            }
  
            .label {
              color: #000000A6;
            }
  
          }
        }
      }
    }
  
    /deep/ .el-tabs__content {
      height: calc(100vh - 310px);
      overflow-y: auto;
      padding-right: 20px;
  
      &::-webkit-scrollbar {
        width: 5px;
      }
  
      &>div {
        width: 1196px;
      }
    }
  }
  </style>